/** Decode URI/HTML leftovers from CMS strings (e.g. `%26` → `&`). */
export function decodeText(value) {
  if (value == null) return '';
  let text = String(value);

  try {
    text = decodeURIComponent(text.replace(/\+/g, ' '));
  } catch {
    // keep original if malformed URI sequences remain
  }

  return text
    .replace(/%26/gi, '&')
    .replace(/%20/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&#38;/g, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/g, "'");
}

/** Ensure a single leading + for stats that may already include one. */
export function formatStat(value) {
  if (value == null || value === '') return '—';
  const str = String(value).trim();
  const bare = str.replace(/^\++/, '');
  return `+${bare}`;
}

/** Title-case nav/footer labels while preserving acronyms like ROI. */
export function toTitleCase(value) {
  const text = decodeText(value).trim();
  if (!text) return '';
  return text
    .split(/(\s+)/)
    .map((part) => {
      if (/^\s+$/.test(part)) return part;
      if (/^[A-Z0-9]{2,}$/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
}
